import classNames from 'classnames'
import React, { useState } from 'react'
import injectStyles from 'react-jss'
import { useDispatch } from 'react-redux'
import UploadDocumentItem from '../../../Containers/City/Page/Ambasador/UploadDocuments/UploadDocumentsForm/UploadDocumentItem'
import { hideReduxModal } from '../../../Reducers/UI/actions'
import GenericFlatButton from '../../GenericFlatButton'

import { styles } from './styles'

const UploadDocModalBody = ({ handleUploadDocument, typeId, classes }) => {
  const [uploadDocuments, setUploadDocuments] = useState(null)
  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()

  const onConfirm = async onCallback => {
    setLoading(true)
    return await handleUploadDocument({
      file: uploadDocuments.file,
      typeId: Number(typeId),
      onCallback: onCallback,
    })
  }

  const hideModals = () => {
    dispatch(hideReduxModal())
  }

  return (
    <div className={classes.modalContainer}>
      <div className={classes.modalTitle}>Uploading new file</div>
      <div className={classes.description}>
        Please select a new file to be uploaded
      </div>
      <div className={classes.dropzone}>
        <UploadDocumentItem
          loading={loading}
          onUploadDocument={setUploadDocuments}
        />
      </div>
      <div
        className={classNames({
          [classes.modalButtonContainer]: true,
          [classes.singleButtonContainer]: loading,
        })}
      >
        {loading ? null : (
          <GenericFlatButton
            type={'outline'}
            title={'Cancel'}
            onClick={() => {
              dispatch(hideReduxModal())
            }}
          />
        )}
        <GenericFlatButton
          type={'filled'}
          title={'Confirm'}
          onClick={async () => {
            await onConfirm(hideModals)
          }}
          loading={loading}
          disabled={!uploadDocuments || loading}
        />
      </div>
    </div>
  )
}

export default injectStyles(styles)(UploadDocModalBody)
